import { render, staticRenderFns } from "./feature-list.vue?vue&type=template&id=386804f6"
import script from "./feature-list.vue?vue&type=script&lang=js"
export * from "./feature-list.vue?vue&type=script&lang=js"
import style0 from "./feature-list.vue?vue&type=style&index=0&id=386804f6&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports